
import { Component } from 'nuxt-property-decorator';
import RawHtml from '../layout/RawHtml.vue';
import Badge from '../Badge.vue';
import AbstractInput from './abstractInput';

@Component({
  components: {
    RawHtml,
    Badge,
  },
})
export default class Instructions extends AbstractInput {}
